export default function getAbsoluteBoundingRect(el) {

    const body = document.body
    const rect = el.getBoundingClientRect()

    let offsetX = window.pageXOffset
    let offsetY = window.pageYOffset

    if(el !== body)
    {
        let parent = el.parentNode

        // The element's rect will be affected by the scroll positions of
        // *all* of its scrollable parents, not just the window, so we have
        // to walk up the tree and collect every scroll offset. Good times.
        while(parent !== body)
        {
            offsetX += parent.scrollLeft
            offsetY += parent.scrollTop
            parent = parent.parentNode
        }
    }

    return {
        bottom: rect.bottom + offsetY,
        height: rect.height,
        left: rect.left + offsetX,
        right : rect.right + offsetX,
        top: rect.top + offsetY,
        width: rect.width
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/getAbsoluteBoundingRect.js